import React from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import Carousel from 'react-multi-carousel'
import "react-multi-carousel/lib/styles.css";
import HtmlLogo from '../assets/html-icon.svg'
import CssLogo from '../assets/css-icon.svg'
import JsLogo from '../assets/javascript-icon.svg'
import ReactLogo from '../assets/react-js-icon.svg'
import GitLogo from '../assets/github-icon.svg'
import BootstrapLogo from '../assets/bootstrap-5-logo-icon.svg'
import TailwindLogo from '../assets/tailwind-css-icon.svg'

import './Skills.css'


const Skills = () => {
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
      };

  return (
    <section className='skill' id='skills'>
        <Container>
            <Row>
                <Col>
                    <div className="skill-bx">
                        <h2>My Skills</h2>
                        <p>Creating responsive and user-friendly websites using HTML, CSS, and JavaScript. Proficient in front-end development, with experience in popular frameworks like Reactjs</p>
                        <Carousel responsive={responsive} infinite={true} className='skill-slider'>
                          <div className="item">
                            <img src={HtmlLogo} alt='IM'/>
                            <h5>HTML</h5>
                          </div>

                          <div className="item">
                            <img src={CssLogo} alt='IM'/>
                            <h5>CSS</h5>
                          </div>

                          <div className="item">
                            <img src={JsLogo} alt='IM'/>
                            <h5>Javascript</h5>
                          </div>

                          <div className="item">
                            <img src={ReactLogo} alt='IM'/>
                            <h5>React</h5>
                          </div>

                          <div className="item">
                            <img src={GitLogo} alt='IM'/>
                            <h5>Git</h5>
                          </div>

                          <div className="item">
                            <img src={BootstrapLogo} alt='IM'/>
                            <h5>Bootstrap</h5>
                          </div>

                          <div className="item">
                            <img src={TailwindLogo} alt='IM'/>
                            <h5>Tailwind CSS</h5>
                          </div>
                          
                        </Carousel>
                    </div>
                </Col>
            </Row>
        </Container>
      </section>
  )
}

export default Skills